import * as yup from 'yup';

export default function stringRequired(label) {
  return yup.string().label().required(label).typeError(label);
}
